import React, { useEffect, useState } from "react";
import {
  formatDateTime,
  isoToSqlDate,
  mergeParams,
} from "../../helpers/helpers";
import api from "../../services/api";
import Form from "../../components/form";
import MUIDataTable from "mui-datatables";

export default function RelatorioPaisFilhos({ history, location }) {
  const [registros, setRegistros] = useState([]);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [tabela, setTabela] = useState(false);

  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        paiNome: "",
        filhoNome: "",
        escolaId: "",
        dataInicial: `${new Date().getFullYear()}-01-01`,
        dataFinal: isoToSqlDate(new Date().toISOString()),
      },
      location
    )
  );

  useEffect(() => {
    carregarComboEscolas();

    if (dadosFiltros.dataInicial && dadosFiltros.dataFinal) {
      carregarRelatorio();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);

    api.get("relatorios/paisFilhos", filtrosEnviar).then((dadosRegistros) => {
      dadosRegistros.forEach((r) => {
        r.ultimoAcesso = r.ultimoAcesso
          ? formatDateTime(r.ultimoAcesso, "D/M/Y h:m")
          : "-";
        r.dataCadastro = r.dataCadastro
          ? formatDateTime(r.dataCadastro, "D/M/Y")
          : "-";
      });
      setRegistros(dadosRegistros);
      setTabela(true);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      paiNome: {
        label: "Pai",
        type: "text",
        space: 4,
        value: dadosFiltros.paiNome,
      },
      filhoNome: {
        label: "Filho",
        type: "text",
        space: 4,
        value: dadosFiltros.filhoNome,
      },
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 4,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escolaId,
      },
      dataInicial: {
        label: "Previsão de início a partir de",
        type: "date",
        space: 6,
        value: dadosFiltros.dataInicial,
      },
      dataFinal: {
        label: "Previsão de início até",
        type: "date",
        space: 6,
        value: dadosFiltros.dataFinal,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  return (
    <div>
      <Form formData={filtros} />
      <br />
      {tabela && (
        <MUIDataTable
          title={"Pais e Filhos Cadastrados"}
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
}

const columns = [
  {
    name: "paiNome",
    label: "Nome",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "filhoNome",
    label: "Filho",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "escolaNome",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "cicloNome",
    label: "Ciclo",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "dataCadastro",
    label: "Data de cadastro",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "ultimoAcesso",
    label: "Último acesso APP",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "plataformaApp",
    label: "Plataforma acesso APP",
    options: {
      filter: true,
      sort: false,
      display: false,
    },
  },
  {
    name: "usuarioEmail",
    label: "Email",
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: "usuarioTelefone",
    label: "Nº Telefone",
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: "dataNascimento",
    label: "Data de nascimento filho",
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "pais_e_filhos.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: true,
      useDisplayedRowsOnly: true,
    },
  },
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  },
};
